<template>
<div>
  <div class="banner">
    <img src="https://firebasestorage.googleapis.com/v0/b/foxfox-honda.appspot.com/o/LOGO_VGxLIA-01.png?alt=media&token=ad128f7b-1718-4830-8534-c06999f9e338" style="height:120px !important;">
  </div><br>
  <section>
    <div class="container">
    <h1 class="title">
        รายการเปลี่ยนแปลงการซ่อม (สาขา {{ branchSelected }})
    </h1>
    </div>
  </section>
  <div class="columns">
    <div class="column is-12"><br>
      <table class="table is-striped is-hoverable" style="width:100%">
        <thead>
          <tr>
            <th><abbr title="runNo">ลำดับที่</abbr></th>
            <th><abbr title="licenseNo">ทะเบียน</abbr></th>
            <th><abbr title="startTime">ชื่อลูกค้า</abbr></th>
            <th><abbr title="expectedDate">วันนัดลูกค้า</abbr></th>
            <th><abbr title="statusOld">สถานะเดิม</abbr></th>
            <th><abbr title="statusNew">สถานะใหม่</abbr></th>
            <th><abbr title="action"></abbr></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="job in jobs" v-bind:key="job.id" >
            <td>{{job.car.runNo}}</td>
            <td>{{job.car.licenseNo}}</td>
            <td>{{job.car.customerName}} <span class="notScan">{{ job.car.userId === -1 ? '(-1)' : ''}}</span></td>
            <td>{{job.car.expectedDate}}</td>
            <td>{{caption[job.from]}}</td>
            <td>{{caption[job.to]}}</td>
            <td align="center">
              <button class="button is-primary" @click="confirmChange(job)" v-if="job.to==='body1' || job.to==='color1' || job.to==='body1_part' || job.to==='body2_part' || job.to==='color1_part' || job.to==='color2_part' || job.to==='color3_part' || job.to==='joinGR' || job.to==='final_inspec' || job.to==='finish'">ยืนยัน & ส่งแจ้งลูกค้า</button>
              <button class="button is-info" @click="confirmChange(job)" v-else>ยืนยัน</button>
              <button class="button is-danger" @click="cancelChange(job)">ยกเลิก</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
</template>

<script>
import draggable from 'vuedraggable'
export default {
  name: 'hello',
  components: {
    draggable
  },
  data: () => ({
    dataAlready: false,
    jobs: [],
    editable: true,
    isDragging: false,
    delayedDragging: false,
    branchSelected: null,
    updatedBy: null,
    branchCode: null,
    branch: null,
    caption: {
      'queueWorkshop': 'รอคิวซ่อม',
      'workshop_waitPart': 'รออะไหล่',
      'workshop_waitCustomer': 'รถไม่อยู่',
      'body1_queue': 'รอเคาะ',
      'body1': 'เคาะ',
      'body1_part': 'เคาะ (รออะไหล่)',
      'body2_queue': 'รอประกอบ',
      'body2': 'ประกอบ',
      'body2_part': 'ประกอบ (รออะไหล่)',
      'color1_queue': 'รอโป๊ว',
      'color1': 'โป๊ว',
      'color1_part': 'โป๊ว (รออะไหล่)',
      'color2_queue': 'รอพ่นสี',
      'color2': 'พ่นสี',
      'color2_part': 'พ่นสี (รออะไหล่)',
      'color3_queue': 'รอขัดสี',
      'color3': 'ขัดสี',
      'color3_part': 'ขัดสี (รออะไหล่)',
      'joinGR': 'ซ่อมร่วม GR',
      'final_inspec': 'ตรวจสอบ',
      'finish': 'พร้อมส่ง'
    }
  }),
  mounted () {
    if (!this.$session.exists() || (typeof this.$session.get('vgroup') === 'undefined' || this.$session.get('vgroup') === '')) {
      this.$router.push('/?redirectUrl=' + encodeURIComponent(window.location.pathname + window.location.search))
    }
    this.updatedBy = this.$session.get('vgroup')
    this.branch = this.$branchList
    const queryString = decodeURIComponent(window.location.search).replace('?liff.state=', '')
    const params = new URLSearchParams(queryString)
    this.branchCode = params.get('branchCode')
    this.branch.map((item) => {
      this.branchSelected = (item.id === this.branchCode) ? item.name : this.branchSelected
      return true
    })
    this.getChange()
  },
  methods: {
    async getChange (step) {
      let _this = this
      _this.dataAlready = false
      this.$axios
        .get(`${this.$apiUrl}getJobsBPChange?branch=${_this.branchCode}`)
        .then(response => {
          _this.dataAlready = true
          _this.jobs = response.data
        })
    },
    async confirmChange (job) {
      let params = {
        changeId: job.id,
        carId: job.car.id,
        current: job.from,
        nextStep: job.to
      }
      await this.$axios
        .post(`${this.$apiUrl}confirmJobsBPChange`, params)
        .then(response => {
          this.updateSuccess = true
          this.getChange()
        })
    },
    async cancelChange (job) {
      let params = {
        changeId: job.id,
        carId: job.car.id,
        current: job.from,
        nextStep: job.to
      }
      await this.$axios
        .post(`${this.$apiUrl}cancelJobsBPChange`, params)
        .then(response => {
          this.updateSuccess = true
          this.getChange()
        })
    },
    add () {
      this.list5.push({'fixed': false, 'name': (Math.floor(Math.random() * 8) + 1) + ' กก ' + (Math.floor(Math.random() * 999) + 1000)})
    },
    orderList () {
      this.list = this.list.sort((one, two) => {
        return one.order - two.order
      })
    },
    onMove ({ relatedContext, draggedContext }) {
      const relatedElement = relatedContext.element
      const draggedElement = draggedContext.element
      return (
        (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
      )
    }
  },
  computed: {
    dragOptions () {
      return {
        animation: 0,
        group: 'description',
        disabled: !this.editable,
        ghostClass: 'ghost'
      }
    },
    listString () {
      return JSON.stringify(this.list, null, 2)
    },
    list2String () {
      return JSON.stringify(this.list2, null, 2)
    }
  },
  watch: {
    isDragging (newValue) {
      if (newValue) {
        this.delayedDragging = true
        return
      }
      this.$nextTick(() => {
        this.delayedDragging = false
      })
    }
  }
}
</script>

<style scoped>
.notScan {
  color: red;
}
.banner {
  text-align: center;
  background-color: #000;
}
.warning {
  color: #000;
  background-color: rgb(255, 112, 112);
}
.success {
  background-color: rgb(112, 255, 112);
}
h3 {
  font-size: 24px;
  font-weight: bold;
}
.container {
  margin: 0 auto;
}
.column {
  margin: 3px;
  background-color: #eee;
}
.is-1 {
  width: 11.65%;
}
.item-queue {
  float: left;
  width: 45%;
  margin-left: 10px;
}
.item-wait {
  float: left;
  width: 30%;
  margin-left: 10px;
}
.flip-list-move {
  transition: transform .5s;
}
.no-move {
  transition: transform 0s;
}
.ghost {
  background: #c8ebfb;
  opacity: .5;
}
.list-group {
  min-height: 350px;
  padding-bottom: 20px;
  background-color: #eee;
}
.list-group-item {
  height: 40px;
  padding: 8px;
  margin-top: 5px;
  background-color: #ccc;
  cursor: move;
}
.list-group-item i {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/BP/change.vue